export const VISUAL_DOCUMENT_LOADING = "VISUAL_DOCUMENT_LOADING";
export const VISUAL_DOCUMENT_SUCCESS = "VISUAL_DOCUMENT_SUCCESS";
export const VISUAL_DOCUMENT_FAILED = "VISUAL_DOCUMENT_FAILED";

export const UPLOAD_FILE_LOADING = "UPLOAD_FILE_LOADING";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILED = "UPLOAD_FILE_FAILED";

export const REMOVE_FILE_LOADING = "REMOVE_FILE_LOADING";
export const REMOVE_FILE_FAILED = "REMOVE_FILE_FAILED";
export const REMOVE_FILE_SUCCESS = "REMOVE_FILE_SUCCESS";


export const SAVE_VISUAL_DATA_LOADING = "SAVE_VISUAL_DATA_LOADING";
export const SAVE_VISUAL_DATA_SUCCESS = "SAVE_VISUAL_DATA_SUCCESS";
export const SAVE_VISUAL_DATA_FAILED = "SAVE_VISUAL_DATA_FAILED";

